import { Textual }	from "@v3/data/textual";

export type Url		= Textual.Value<typeof Url>;
export const Url	= Textual.regex("Url", /^\S+$/, "must be a non-empty url without blanks");
